/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Whats_New_DescriptionInputs */



/**
* | output |
* | --- |
* | "Recent changes and additions" |
*
* @param {Layout_Header_Whats_New_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_whats_new_description = /** @type {((inputs?: Layout_Header_Whats_New_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Whats_New_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Änderungen und Ergänzungen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Changements et ajouts récents")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("最近的改动与新增")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("近期的變更與新增功能")
	if (locale === "ko") return /** @type {LocalizedString} */ ("최근 변경 사항과 추가 기능")
	return /** @type {LocalizedString} */ ("Recent changes and additions")
});